import React from 'react';

import { Spin } from 'antd';

interface IProps {
  title: string;
  children: React.ReactNode;
  loading?: boolean;
  action?: React.ReactNode;
}

export function FormContent(props: IProps) {
  const { children, loading = false, title, action } = props;

  return (
    <div className='border-border flex-1 rounded border bg-white'>
      {!!title && (
        <div className='border-border flex items-center justify-between border-b bg-white'>
          <span className='p-[12px] text-[16px] font-bold'>{title}</span>
          {action && <div className='mr-4'>{action}</div>}
        </div>
      )}
      <Spin spinning={loading}>
        <div className={loading ? 'pointer-events-none w-full p-[12px] opacity-30' : 'w-full p-[12px]'}>{children}</div>
      </Spin>
    </div>
  );
}
